import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

interface PortalStyleContextValue {
  portalClassName: string;
}

const PortalStyleContext = createContext<PortalStyleContextValue>({ portalClassName: '' });

export const usePortalStyleContext = () => useContext(PortalStyleContext);

export const usePortalStyle = () => {
  const [portalClassName, setPortalClassName] = useState('');

  const setContainerRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      setPortalClassName(node.className);
    }
  }, []);

  const PortalStyleProvider = useMemo(() => {
    return ({ children }: { children: React.ReactNode }) => (
      <PortalStyleContext.Provider value={{ portalClassName }}>{children}</PortalStyleContext.Provider>
    );
  }, [portalClassName]);

  return { setContainerRef, PortalStyleProvider };
};

export { PortalStyleContext };
